import { useGetList } from "ra-core";

import { GravunDashboard } from "../../gravun/dashboard/GravunDashboard";
import type { Contact, ContactNote } from "../types";
import { DashboardStepper } from "./DashboardStepper";

/**
 * Desktop dashboard entry point. Keeps Atomic's first-run onboarding stepper
 * (create first contact/note), then renders the Gravun dashboard.
 */
export const Dashboard = () => {
  const {
    data: dataContact,
    total: totalContact,
    isPending: isPendingContact,
  } = useGetList<Contact>("contacts", {
    pagination: { page: 1, perPage: 1 },
  });

  const { total: totalContactNotes, isPending: isPendingContactNotes } =
    useGetList<ContactNote>("contact_notes", {
      pagination: { page: 1, perPage: 1 },
    });

  const isPending = isPendingContact || isPendingContactNotes;

  if (isPending) {
    return null;
  }

  if (!totalContact) {
    return <DashboardStepper step={1} />;
  }

  if (!totalContactNotes) {
    return <DashboardStepper step={2} contactId={dataContact?.[0]?.id} />;
  }

  return <GravunDashboard />;
};
